import {__} from "../util/dom";
import breakQueryString from "../util/breakQueryString";

export default function carouselPaging() {

    init();
    trackChanges();

}

const tabNav = $('.sectionTabs');
const tabs = [].slice.call(__(".sectionTab a"));
const headerSections = [].slice.call(__(".headerSection"));
const questions = [].slice.call(__(".carousel-item"));
const leftButtons = [].slice.call(__(".carousel-navigation-btn-left"));
const rightButtons = [].slice.call(__(".carousel-navigation-btn-right"));

// helpers

function stripPrefix(str) {
    return str.substr(str.lastIndexOf('-') + 1);
}

function listElementById(list, compareTo, listItemCompareColumn = 'id') {
    compareTo = parseInt(compareTo);
    return list.find(item => parseInt(stripPrefix(item[listItemCompareColumn])) === compareTo);
}

function buttonElementsById(leftButtons, rightButtons, compareTo, listItemCompareColumn = 'id') {
    compareTo = parseInt(compareTo);
    return [leftButtons.find(item => parseInt(stripPrefix(item[listItemCompareColumn])) === compareTo), rightButtons.find(item => parseInt(stripPrefix(item[listItemCompareColumn])) === compareTo)];
}

function tabById(headerId) {
    return listElementById(tabs, headerId, 'href');
}

function sectionById(headerId) {
    return listElementById(headerSections, headerId);
}

function buttonsById(headerId) {
    return buttonElementsById(leftButtons, rightButtons, headerId);
}

function questionById(questionId) {
    return listElementById(questions, questionId);
}

function fullIdForHeader(headerId) {
    const section = sectionById(headerId);
    return section.id;
}

function sectionCarousel(headerSection) {
    return headerSection.children[0];
}

function questionHeader(question) {
    return question.parentNode.parentNode;
}

function activeTab() {
    return tabs.find(tab => tab.classList.contains("active"));
}

function activeQuestion(header) {
    return Array.from(sectionCarousel(header).children)
        .find(question => question.classList.contains("active"));
}

function selectHeader(headerId) {
    tabNav.tabs('select_tab', fullIdForHeader(headerId));
}

function selectQuestion(section, question) {
    $(sectionCarousel(section)).carousel('set', question.dataset.index);
}

function navigateTo(headerId, questionId) {
    const section = sectionById(headerId);
    const question = questionById(questionId);

    selectHeader(headerId);
    selectQuestion(section, question);
}

// bind and listen for changes

function trackChanges() {
    $('.tabs a').on('click', handleHeaderChange);
    $('.indicator-item').on('click', handleQuestionChange);
    $('.carousel-navigation-btn-left').on('click', handleButtonClick);
    $('.carousel-navigation-btn-right').on('click', handleButtonClick);
}

// putting it all together

function init() {
    const search = breakQueryString(window.location.search);

    if(!search || !search.q) {
        return;
    }

    const questionId = search.q;
    const question = questionById(questionId);
    const section = questionHeader(question);
    const tab = tabById(stripPrefix(section.id));

    // we can't use navigateTo() here as the tabs don't seem to have been initialized yet
    // by the Materialize JS so we'll add the class active so that it'll set it when it does load
    tab.classList.add("active");
    selectQuestion(section, question);
}

function handleHeaderChange(evt) {
    const tab = evt.currentTarget;
    const headerId = stripPrefix(tab.href);
    const activeButtons = buttonsById(headerId);
    setActiveButtons(activeButtons);
    const section = sectionById(headerId);
    const questionId = stripPrefix(activeQuestion(section).id);
    updateUrl(questionId);
}

function setActiveButtons(activeButtons) {
    leftButtons.forEach(function(button) {
        let selector = '#' + button.id;
        if (button.id === activeButtons[0].id) {
            $(selector).css('display', 'inline');
        }
        else {
            $(selector).css('display', 'none');
        }
    });

    rightButtons.forEach(function(button) {
        let selector = '#' + button.id;
        if (button.id === activeButtons[1].id) {
            $(selector).css('display', 'inline');
        }
        else {
            $(selector).css('display', 'none');
        }
    });
}

function handleQuestionChange() {
    const headerId = stripPrefix(activeTab().href);
    const section = sectionById(headerId);
    const questionId = stripPrefix(activeQuestion(section).id);

    updateUrl(questionId);
}

function handleButtonClick() {
    setTimeout(() => handleQuestionChange(), 500);
}

export function navigateToQuestion(questionId) {
    const question = questionById(questionId);
    const headerSection = questionHeader(question);
    const headerId = stripPrefix(headerSection.id);

    navigateTo(headerId, questionId);
}

export function updateUrl(question) {
    const path = `?q=${question}`;
    if(window.location.search !== path) {
        window.history.replaceState(null, '', path);
    }
}
